<template>
  <div class="brain-task-toast">
    <BrainTaskToastHeader
      :icon="['fal', 'palette']"
      :title="$t(`${i18n}.title`)"
      :closable="closable"
      @close="$emit('close')"
    />

    <BrainTaskToastBody
      :status="status"
      :status-configs="statusConfigs"
      @click:cta="handleCTA"
    />
  </div>
</template>

<script>
import BrainTaskToastHeader from './BrainTaskToastHeader.vue';
import BrainTaskToastBody from './BrainTaskToastBody.vue';

const i18n = 'generate-image-cover.loading-toast';

export default {
  name: 'brain-generate-image-cover-toast',
  components: {
    BrainTaskToastHeader,
    BrainTaskToastBody,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      i18n: 'generate-image-cover.loading-toast',
      statusConfigs: {
        loading: {
          loading: true,
          description: this.$t(`${i18n}.loading`),
          closable: true,
        },
        pending: {
          loading: true,
          description: this.$t(`${i18n}.pending`),
          closable: true,
        },
        done: {
          description: this.$t(`${i18n}.done`),
          closable: true,
        },
        failed: {
          title: this.$t(`${i18n}.failed-title`),
          description: this.$t(`${i18n}.failed-description`),
          cta: this.$t(`${i18n}.failed-button`),
          closable: true,
        },
      },
    };
  },
  computed: {
    closable() {
      try {
        return this.statusConfigs[this.status].closable;
      } catch (_e) {
        return true;
      }
    },
  },
  methods: {
    handleCTA(status) {
      switch (status) {
        case 'done':
          return this.$emit('click:refresh');
        case 'failed':
          return this.$emit('click:retry');
        default:
          return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.brain-task-toast {
  width: 100%;
  font-size: 14px;
  border-radius: 8px;
  background-color: white;
  overflow: hidden;
  color: $purple-5-mayday;
  border: rgba($purple-5-mayday, 0.5) 1px solid;
}
</style>
